import React, { Fragment } from "react";
import "./Contactus.css";
import Fade from 'react-reveal/Fade';
import { Dimensions } from '../../Helper/sitedimension';
import { Link } from "react-router-dom";

const contactus = () => {
  const { width } = Dimensions.useWindowDimensions();
  return (
    <Fragment>
      {width > 500 ?
        <div className="contactus2">
          <div className="container-fluid bg-1">
            <div className="main">
              <h2 className="content"><Fade delay={300}>Interested in va & pt</Fade></h2>
            </div>
            <div className="btn-pos">
              <Fade delay={600}>
                <Link to='/contactus'>
                  <button className="btn1">
                    <span className="btn-content">Contact Us &nbsp;</span>
                  </button>
                </Link>
              </Fade>
            </div>
          </div>
        </div> :
        <div className="conmobileab">
          <div className="maincon" >
            <h2 className="contentcon">
              <Fade delay={300}>Interested in va & pt </Fade>
            </h2>
          </div>
          <div className="btn-poscon">
            <Fade delay={600}>
              <Link to='/contactus'>
                <button className="btn1con">
                  <span className="btn-contentcon">Contact Us &nbsp;</span>
                </button>
              </Link>
            </Fade>
          </div>
        </div>
      }
    </Fragment>
  );
};

export default contactus;
